// Tracks whether the terrain analysis overlay is currently active (applied + enabled).
// The Viewshed component subscribes so it knows whether to show the independent canvas
// or defer to TerrainOverlay for combined-mode rendering.

const _listeners = new Set()
let _active = false

export const terrainStore = {
  get active() { return _active },

  set(v) {
    _active = v
    _listeners.forEach(fn => fn())
  },

  onChange(fn) {
    _listeners.add(fn)
    return () => _listeners.delete(fn)
  },
}
